module.exports = __webpack_public_path__ + "img/pic_618youhui.46c808b5.png";